#import "./lead-stages-edge-fragment.graphql"
#import "./lead-assignable-fragment.graphql"
#import "./lead-value-fragment.graphql"
#import "../../../../core-entity/graphql/fragments/widget-fragment.graphql"
#import "../../../sidebar/lead-researcher-widget/graphql/fragments/lead-research-fragment.graphql"

fragment Lead on Lead {
    id
    type
    name
    bccAddress
    number
    territory
    avatarUrl
    status
    priority
    isHot
    isOverdue
    createdTime
    deletedTime
    confidence
    closedTime
    anticipatedClosedTime
    isCurrentUserWatching
    stageOverdueTime
    assignee {
        ...LeadAssignable
    }
    creator {
        id
        name
    }
    ...LeadValueFragment
    clonedFrom {
        id
        number
        htmlUrl
    }
    stages {
        current {
            id
            name
            deletedTime
            avatarUrl
        }
        totalCount
        edges {
            ...LeadStagesEdge
        }
    }
    stageset {
        id
        type
        default
        name
        stages {
            id
            name
        }
        isArchived
    }
    stagesetForWidgets {
        id
        name
        sidebarWidgets {
            ...WidgetFragment
        }
        workspaceWidgets {
            ...WidgetFragment
        }
    }
    tags {
        id
        name
        color
        creator {
            id
            name
        }
    }
    tagMaps(first: 1000) {
        edges {
            creator {
                id
                name
            }
            createdTime
            node {
                id
                name
                color
                creator {
                    id
                    name
                }
                createdTime
            }
        }
    }
    outcome {
        id
        name
    }
    deletedTime
    sendToDestinations {
        name
        localUrl
    }
    externalResources {
        externalService
        externalResourceType
        externalId
    }
    research {
        canResearch
        summary {
            ...LeadResearchSummaryFragment
        }
    }
}
